import { useState, useEffect, useContext } from 'react'
import { useMutation, useLazyQuery } from "@apollo/client";
import { PUBLISHERCATALOGS } from "../../graphql/queries";
import {
    UPDATE_PUBLISHER
} from "../../graphql/mutations";
import { useStore } from "../../Store";
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';

export const useCatalogs = () => {
    const {user, publisher} = useContext(PublisherAndUserContext);
    const {updateStates} = useStore((state) => state);
    const [catalogs, setCatalogs] = useState([]);
    const [isCatalogListOrderChanged, setIsCatalogListOrderChanged] =
        useState(false);
    const [loading, setLoading] = useState(false);

    const [getCatalogs] = useLazyQuery(PUBLISHERCATALOGS, {
        onCompleted: (data) => {
            setCatalogs(
                data.publisher.catalogs.map((catalog, cindex) => ({
                    ...catalog,
                    index:
                        typeof catalog.index === "object"
                            ? cindex + 1
                            : catalog.index === cindex + 2
                                ? cindex + 1
                                : catalog.index,
                }))
            );
            setLoading(false);
        },
        onError: () => {
            setLoading(false);
        },
        fetchPolicy: "cache-and-network",
    });

    useEffect(() => {
        if (publisher?.id) {
            setLoading(true);
            getCatalogs({
                variables: { where: { id: publisher?.id } },
            });
        }
    }, [publisher?.id, getCatalogs]);

    const storeCatalogInfo = (catalogId) => {
        const catalog = catalogs.find(cat => 
            cat.id === catalogId
        )
        updateStates({
            catalg: catalog
        })
    }

    const [updatePublisher] = useMutation(UPDATE_PUBLISHER);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (isCatalogListOrderChanged) {
                setIsCatalogListOrderChanged(false);
                updatePublisher({
                    variables: {
                        where: {
                            id: publisher.id,
                        },
                        data: {
                            catalogs: {
                                update: catalogs.map((catalogList) => ({
                                    where: { id: catalogList.id },
                                    data: { index: {set: catalogList.index} },
                                })),
                            },
                        },
                    },
                });
            }
        }, 400);
        return () => {
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCatalogListOrderChanged]);

    return {
        user,
        catalogs,
        loading,
        storeCatalogInfo
    }
}
